import { render, staticRenderFns } from "./StadiumBoostUpdateCustomerForm.vue?vue&type=template&id=5d99d9be&"
import script from "./StadiumBoostUpdateCustomerForm.vue?vue&type=script&lang=js&"
export * from "./StadiumBoostUpdateCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d99d9be')) {
      api.createRecord('5d99d9be', component.options)
    } else {
      api.reload('5d99d9be', component.options)
    }
    module.hot.accept("./StadiumBoostUpdateCustomerForm.vue?vue&type=template&id=5d99d9be&", function () {
      api.rerender('5d99d9be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumBoostUpdateCustomerForm.vue"
export default component.exports